export default __webpack_public_path__ + "static/media/choc.5546989a.png";